<template>
  <b-table
    :data="data"
    :loading="loading"
    paginated
    backend-pagination
    :total="total"
    :per-page="perPage"
    @page-change="onPageChange"
    aria-next-label="Próxima Página"
    aria-previous-label="Página Anterior"
    aria-page-label="Página"
    aria-current-label="Página Atual"
    draggable
    @dragstart="dragstart"
    @drop="drop"
    @dragover="dragover"
    @dragleave="dragleave"
  >
    <template slot-scope="props">
      <b-table-column field="id" label="Ativo" width="5%">
        <span>
          <b-icon
            v-if="props.row.active"
            size="is-small"
            icon="check"
            type="is-success"
          ></b-icon>
          <b-icon
            v-if="!props.row.active"
            size="is-small"
            icon="cancel"
            type="is-danger"
          ></b-icon>
        </span>
      </b-table-column>
      <b-table-column field="image" label="Imagem"
        ><img :src="props.row.image" alt="Imagem do Destaque"
      /></b-table-column>
      <b-table-column field="name" label="Nome" width="40%">{{
        props.row.name
      }}</b-table-column>
      <b-table-column field="points" label="Pontos">{{
        props.row.points
      }}</b-table-column>
      <b-table-column label="Opções">
        <button
          v-if="page >= 2 && props.index == 0"
          @click="moveToPreviousPage(props.row)"
          v-app-button.icon-only
          title="Mover para cima"
        >
          <b-icon size="is-small" icon="arrow-up"></b-icon>
        </button>
        <button
          @click="edit(props.row.id)"
          v-app-button.icon-only
          v-tooltip.bottom="'Editar'"
        >
          <b-icon size="is-small" icon="pencil"></b-icon>
        </button>
        <button
          @click="onClickDeleteHighlight(props.row.id)"
          v-app-button.icon-only
          v-tooltip.bottom="'Excluir'"
          color="danger"
        >
          <b-icon size="is-small" icon="delete"></b-icon>
        </button>
      </b-table-column>
    </template>
    <template slot="empty">
      <section class="section">
        <div class="content has-text-grey has-text-centered">
          <p>
            <b-icon icon="emoticon-sad" size="is-large"></b-icon>
          </p>
          <p>Nenhum registro encontrado.</p>
        </div>
      </section>
    </template>
  </b-table>
</template>

<script>
import StoreHighlightsService from '@/services/store-highlights.service';
import DraggableTableMixin from '@/mixins/DraggableTableMixin';
import ToastMixin from '@/mixins/ToastifyMixin';

export default {
  name: 'store-highlight-table',
  mixins: [ToastMixin, DraggableTableMixin],
  data: () => {
    return {
      data: [],
      columns: [],
      total: 0,
      loading: false,
      page: 1,
      perPage: 10,
    };
  },
  methods: {
    load() {
      this.loading = true;

      StoreHighlightsService.get({
        page: this.page,
        perPage: this.perPage,
      })
        .then((response) => {
          const { total, data } = response.data;
          this.total = total;
          this.data = data;
        })
        .catch(() => this.toastify('Erro ao carregar Destaques.', 'error'))
        .finally(() => (this.loading = false));
    },
    edit(id) {
      this.$router.push(`${id}/edit`);
    },
    onClickDeleteHighlight(id) {
      this.$buefy.dialog.confirm({
        title: 'Excluindo Campanha',
        message:
          'Tem certeza que deseja <b>excluir</b> este destaque? Essa ação não pode ser desfeita.',
        cancelText: 'Cancelar',
        confirmText: 'Excluir destaque',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.deleteHighlight(id),
      });
    },
    deleteHighlight(id) {
      StoreHighlightsService.delete(id)
        .then(() => {
          this.toastify('Destaque excluído com sucesso.');
          this.load();
        })
        .catch(({ response }) => {
          this.toastify(
            response.data.message || 'Erro ao tentar excluir Destaque.',
            'error'
          );
        });
    },
    onOrderChange(highlightId, from, to) {
      const replaceOrder = this.data[to].order;
      this.data = this.reorderArray(this.data, from, to);

      StoreHighlightsService.reorder(highlightId, replaceOrder)
        .then(() => this.toastify('Ordem atualizada'))
        .catch(({ response }) => {
          this.toastify(
            response.data.message || 'Erro ao atualizar os destaques.',
            'error'
          );
        });
    },
    moveToPreviousPage(highlight) {
      StoreHighlightsService.moveUp(highlight.id).then(() => this.load());
    },
    onPageChange(page) {
      this.page = page;
      this.load();
    },
  },
  mounted() {
    this.load();
  },
};
</script>

<style lang="scss" scoped>
img {
  width: 100px;
  height: 100px;
}
</style>
